import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

const Staff = (props) => {
  const staff = props.site.staff || [];

  return (
    <div>
      <div className="sectionIntro">
        {/* <span className="sectionIntro__eyebrow">Team</span> */}
        <h2 className="sectionIntro__title">{props.site.staffPageTitle}</h2>
        <p className="sectionIntro__text">{props.site.staffDescription}</p>
      </div>

      <Swiper
        className="siteCarousel"
        spaceBetween={16}
        slidesPerView={1.15}
        pagination={{ clickable: true }}
        modules={[Pagination]}
        centerInsufficientSlides={true}
        breakpoints={{
          480: { slidesPerView: 1.35, spaceBetween: 16 },
          640: { slidesPerView: 2.1, spaceBetween: 18 },
          900: { slidesPerView: 3, spaceBetween: 20 },
          1200: { slidesPerView: 4, spaceBetween: 22 },
        }}
      >
        {staff.map((val, i) => (
          <SwiperSlide key={i}>
            <article className="staffCard">
              <div className="staffCard__mediaWrap">
                <img
                  loading="lazy"
                  alt={val.name}
                  className="staffCard__image"
                  src={process.env.REACT_APP_API_SERVICE_BASE_URL + "image/BarberProfileImages/" + val.imageFileName}
                />
              </div>
              <div className="staffCard__body">
                <h3 className="staffCard__name">{val.name}</h3>
              </div>
            </article>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Staff;
